// extracted by mini-css-extract-plugin
export default {"wrap":"s_wrap__hacNa","item":"s_item__DAX1n","active":"s_active__HeWSo"};